import { Component } from "react";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import { uuid } from "@/utils/string"; // Adjust the import based on your project structure
import { OnEndedHandlerProps } from "@/types"; // Adjust the import based on your project structure

interface VideoPlayerProps {
  url: string;
  type?: "video" | "audio";
  provider?: "html5" | "youtube" | "vimeo";
  onEnd?: (props: OnEndedHandlerProps) => void;
  currentTime?: number;
  completed?: boolean;
}

interface VideoPlayerState {}

class VideoPlayer extends Component<VideoPlayerProps, VideoPlayerState> {
  private player: Plyr | null = null;

  private id: string = uuid("video");

  componentDidMount() {
    const {
      url,
      provider,
      type = "video",
      currentTime,
      completed,
      onEnd,
      ...rest
    } = this.props;
    const options = { ...rest };

    this.player = new Plyr(`#${this.id}`, options);

    if (this.player) {
      this.player.source = {
        type,
        sources: [
          {
            src: url,
            provider,
          },
        ],
      };

      if (currentTime) {
        this.player.on("loadeddata", () => {
          if (currentTime < this.player!.duration) {
            this.player!.currentTime = currentTime;
          }
        });
      }

      this.player.on("ended", () => {
        if (onEnd) {
          this.onEndedHandler();
        }
      });
    }
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.destroy();
    }
  }

  onEndedHandler = () => {
    const { onEnd } = this.props;
    if (this.player && onEnd) {
      onEnd({
        timer: Number(this.player.currentTime.toFixed(2)),
        duration: this.player.duration,
        completed: this.player.currentTime >= this.player.duration - 5,
      });
    }
  };

  render() {
    return (
      <video id={this.id} className="plyr" controls>
        <track kind="captions" />
      </video>
    );
  }
}

export default VideoPlayer;
